export default "__VITE_ASSET__BoqIsQ2y__"